import React from "react";
import SectionList, { SectionTypes } from "../sections/SectionList";
import TopBox from "../common/TopBox";
import { RouteName, RouteParams } from "../../lib/routes";
import { SubNavLinksType } from "../common/TopBox/SubNav";
import Seo from "../../lib/models/seo";

export interface Props {
  route: RouteName;
  params?: RouteParams;
  title: string;
  contents?: {
    items?: SectionTypes[];
  };
  subLinks?: SubNavLinksType;
  seo?: Seo;
}

export default function SimplePage(props: Props) {
  return (
    <>
      <TopBox
        title={props.title}
        breadCrumpPath={[
          { route: props.route, title: props.title, params: props.params }
        ]}
        subLinks={props.subLinks}
      />
      {props.contents && props.contents.items && (
        <SectionList sections={props.contents.items} main />
      )}
    </>
  );
}

SimplePage.getImages = (props: Partial<Props>) => {
  if (!props.contents || !props.contents.items) return [];

  return SectionList.getImages({ sections: props.contents.items });
};
